import { Dialog, DialogTitle, Typography } from "@material-ui/core"
import CreateNewReviewerForm from "components/Forms/CreateNewReviewerForm"
import AppContext from "contexts/App"
import { useContext } from "react"

import useStyles from "./styles"

const CreateNewReviewer = () => {
  const classes = useStyles()

  const { dialogs, closeDialog } = useContext(AppContext)
  const thisDialog = dialogs?.["createNewReviewer"] || {}
  const { open = false, data = {} } = thisDialog

  const handleClose = () => {
    closeDialog("createNewReviewer")
  }

  return (
    <Dialog open={open} classes={{ paperWidthSm: classes.paper }}>
      <DialogTitle disableTypography>
        <Typography variant="h2">Add New Reviewer</Typography>
      </DialogTitle>
      <CreateNewReviewerForm
        handleClose={handleClose}
        entityId={data?.entityId}
      />
    </Dialog>
  )
}

export default CreateNewReviewer
